import { gql } from "@apollo/client";

export const UPDATE_COMPANY_USER_MUTATION = gql`
  mutation UpdateCompanyUser($input: UpdateCompanyUserInput!) {
  updateCompanyUser(input: $input) {
      id
      email
    firstName
    lastName
    phoneNumber
    countryCode
    
  }
}
`;

// Delete Company User Mutation (for delete and leave company)

export const DELETE_COMPANY_USER_MUTATION = gql`
  mutation DeleteCompanyUser($userId: ID!) {
    deleteCompanyUser(userId: $userId)
  }
`;

// Accept Invitation Mutation

export const UPDATE_COMPANY_MUTATION = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      id
      name
      email
      address
      country
      city
      state
      zip
      phoneNumber
      countryCode
      website
      industry
      businessType
      subdomain
      notes
      inspectionOrderGeneratorEnabled
    }
  }
`;

// Product Mutations
